import { SearchType } from '@/types/most-search-type';

interface BuildMessageParams {
  procedureName: string;
  city: string;
  state: string;
}

export const scheduleProcedureWhatsappMessage = {
  [SearchType.PRESENTIAL_CONSULTATION]: ({ procedureName, city, state }: BuildMessageParams) =>
    ` Olá! Gostaria de agendar uma consulta com ${procedureName} em ${city} - ${state}.`,
  [SearchType.LABORATORIAL_EXAM]: ({ procedureName, city, state }: BuildMessageParams) =>
    ` Olá! Gostaria de agendar o exame ${procedureName} em ${city} - ${state}.`,
};

export const scheduleDefaultWhatsappMessage = 'Olá! Gostaria de realizar um agendamento com a Medprev.';

export const branchDefaultWhatsappMessage
  = 'Olá! Estava no site da Medprev e gostaria de mais informações sobre esta unidade.';

export const patientSacWhatsappMessage = 'Olá! Sou paciente Medprev e preciso de suporte.';

export const partnerSacWhatsappMessage = 'Olá! Sou parceiro Medprev e preciso de suporte.';

export const needHelpWhatsappMessage = 'Oi, estava no Agendamento Online da Medprev e preciso de ajuda.';
